// ============================================================
// api/authorityGrants.js  (2026-10-05)
// Admin-portal client for the NAMED grants (decisions.md "Authority comes
// from GRANTS that are on by default"): audit sign-off, CarePlan settings,
// care tasks and the termination data export.
//
// Backend: shared/authority-grants-admin.js
//   GET    /mgmt/admin/users/{id}/authority-grants        -> { roleKey, grantable, onByDefault, grants[] }
//   POST   /mgmt/admin/users/{id}/authority-grants        { authorityKey }
//   DELETE /mgmt/admin/users/{id}/authority-grants/{key}  (a removal is FINAL)
// ============================================================

import { apiGet, apiPost, apiDelete } from './client';

export async function getAuthorityGrants(clientUserId) {
  return apiGet(`/mgmt/admin/users/${clientUserId}/authority-grants`);
}

export async function grantAuthority(clientUserId, authorityKey) {
  return apiPost(`/mgmt/admin/users/${clientUserId}/authority-grants`, { authorityKey });
}

export async function revokeAuthority(clientUserId, authorityKey) {
  return apiDelete(`/mgmt/admin/users/${clientUserId}/authority-grants/${encodeURIComponent(authorityKey)}`);
}
